import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./features/authSlice";
import servicesReducer from "./features/servicesSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    services: servicesReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
